// extracted by mini-css-extract-plugin
module.exports = {"corp":"Footer_corp__NtB7b","logoImg":"Footer_logoImg__igjNX"};